import { combineReducers } from 'redux';

import vehicleReducer from './Vehicle/vehicle.reducer';
import driverReducer from './Driver/driver.reducer';
import fleetReducer from './Fleet/fleet.reducer';
import authReducer from './Auth/auth.reducer';
import appReducer from './App/app.reducer';

export default combineReducers({
  vehicleState: vehicleReducer,
  driverState: driverReducer,
  fleetState: fleetReducer,
  authState: authReducer,
  appState: appReducer,
});



// WEBPACK FOOTER //
// ./src/reducers.js